(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reference-hero')) {
    customElements.define('reference-hero', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-index]')];
        this.index = 0;
        this.timer = null;
        this.hovered = false;
        this.focused = false;
        this.editorSelected = false;
        this.inView = true;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.pauseButton = this.querySelector('[data-pause]');
        this.controls = this.querySelector('.rh-hero__controls');
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-next')) this.show(this.index + 1);
          if (button.hasAttribute('data-previous')) this.show(this.index - 1);
          if (button.hasAttribute('data-index')) this.show(Number(button.dataset.index));
          if (button.hasAttribute('data-pause')) {
            this.paused = !this.paused;
            this.updatePause();
          }
          this.schedule();
        }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', event => {
          if (event.matches) this.paused = true;
          this.updatePause(); this.schedule();
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
          if (index >= 0) { this.editorSelected = true; this.show(index); this.schedule(); }
        }, options);
        this.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); }, options);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.schedule();
        });
        this.observer.observe(this);
        this.updatePause();
        this.show(0);
        this.schedule();
      }
      show(index) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === this.index);
          if (i === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (this.controls) this.controls.style.setProperty('--controls-color', getComputedStyle(this.slides[this.index]).getPropertyValue('--slide-text'));
      }
      updatePause() {
        if (!this.pauseButton) return;
        this.pauseButton.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
        this.pauseButton.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
      }
      schedule() {
        clearTimeout(this.timer);
        const running = this.dataset.autoplay === 'true' && this.slides.length > 1 && !this.paused && !this.hovered && !this.focused && !document.hidden && !this.editorSelected && this.inView;
        this.querySelector('.rh-hero__slides').setAttribute('aria-live', running ? 'off' : 'polite');
        if (running) this.timer = setTimeout(() => { this.show(this.index + 1); this.schedule(); }, Math.max(2000, Number(this.dataset.speed) || 5000));
      }
      disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muscle-madness-branches"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mm-branch-carousel')){
 customElements.define('mm-branch-carousel',class extends HTMLElement{
  connectedCallback(){
   this.abort?.abort();this.abort=new AbortController();
   const opts={signal:this.abort.signal};const rail=this.querySelector('[data-rail]');if(!rail)return;
   const prev=this.querySelector('[data-move="-1"]'),next=this.querySelector('[data-move="1"]');
   const update=()=>{const max=rail.scrollWidth-rail.clientWidth;prev.hidden=next.hidden=max<2;prev.disabled=rail.scrollLeft<=1;next.disabled=rail.scrollLeft>=max-1;};
   this.addEventListener('click',e=>{const button=e.target.closest('[data-move]');if(!button||!rail.firstElementChild)return;const step=rail.firstElementChild.getBoundingClientRect().width+(parseFloat(getComputedStyle(rail).columnGap)||0);rail.scrollBy({left:Number(button.dataset.move)*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});},opts);
   rail.addEventListener('scroll',update,{...opts,passive:true});
   this.resize?.disconnect();this.resize=new ResizeObserver(update);this.resize.observe(rail);
   this.addEventListener('shopify:block:select',e=>{const card=[...rail.children].find(c=>c.dataset.blockId===e.detail?.blockId);if(card)rail.scrollBy({left:card.getBoundingClientRect().left-rail.getBoundingClientRect().left,behavior:'instant'});},opts);
   update();
  }
  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reference-benefits"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rf-benefits-carousel-v2')) {
  customElements.define('rf-benefits-carousel-v2', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.track = this.querySelector('.rf-benefits__items');
      if (!this.track) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelectorAll('[data-step]').forEach(button => {
        button.addEventListener('click', () => this.move(Number(button.dataset.step)), options);
      });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
      }, options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('.rf-benefits__item') || Array.from(this.track.children).find(item => item.dataset.blockId === event.detail?.blockId);
        if (item && this.contains(item)) item.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      Array.from(this.track.children).forEach(item => this.observer.observe(item));
      this.classList.add('is-ready');
      this.cleanup = true;
      this.update();
    }
    move(step) {
      const first = this.track.firstElementChild;
      if (!first) return;
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({
        left: step * (first.getBoundingClientRect().width + gap) * (rtl ? -1 : 1),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
    update() {
      const first = this.track.firstElementChild;
      const last = this.track.lastElementChild;
      const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
      this.classList.toggle('has-overflow', overflow);
      const viewport = this.track.getBoundingClientRect();
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const firstRect = first?.getBoundingClientRect();
      const lastRect = last?.getBoundingClientRect();
      const atStart = !firstRect || (rtl ? firstRect.right <= viewport.right + 2 : firstRect.left >= viewport.left - 2);
      const atEnd = !lastRect || (rtl ? lastRect.left >= viewport.left - 2 : lastRect.right <= viewport.right + 2);
      const previous = this.querySelector('[data-step="-1"]');
      const next = this.querySelector('[data-step="1"]');
      if (previous) previous.disabled = !overflow || atStart;
      if (next) next.disabled = !overflow || atEnd;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.cleanup = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reference-collections"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('reference-card-rail')) {
 customElements.define('reference-card-rail', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.abort = new AbortController();
   const opts = {signal:this.abort.signal};
   this.rail=this.querySelector('[data-rail]');
   if (!this.rail) return;
   this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
   this.addEventListener('click', e=>{
    const move=e.target.closest('[data-move]');
    if(move){
     const card=this.rail.firstElementChild;
     if(card){const gap=parseFloat(getComputedStyle(this.rail).columnGap)||0;this.rail.scrollBy({left:Number(move.dataset.move)*(card.getBoundingClientRect().width+gap),behavior:this.reduced.matches?'instant':'smooth'});}
    }
    const opener=e.target.closest('[data-quick-view]');
    if(opener){const dialog=document.getElementById(opener.dataset.quickView);if(dialog?.showModal){this.lastOpener=opener;dialog.showModal();}}
    if(e.target.closest('[data-close]')) e.target.closest('dialog')?.close();
    if(e.target.tagName==='DIALOG'){
     const r=e.target.getBoundingClientRect();
     if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)e.target.close();
    }
   },opts);
   this.querySelectorAll('dialog').forEach(d=>d.addEventListener('close',()=>this.lastOpener?.focus(),opts));
   this.update=()=>{
    const max=this.rail.scrollWidth-this.rail.clientWidth;
    const prev=this.querySelector('[data-move="-1"]'),next=this.querySelector('[data-move="1"]');
    if(prev){prev.hidden=max<2;prev.disabled=this.rail.scrollLeft<=1;}
    if(next){next.hidden=max<2;next.disabled=this.rail.scrollLeft>=max-1;}
   };
   this.rail.addEventListener('scroll',this.update,{...opts,passive:true});
   this.resize=new ResizeObserver(this.update);this.resize.observe(this.rail);
   this.addEventListener('shopify:block:select',e=>{
    const card=[...this.rail.children].find(c=>c.dataset.blockId===e.detail?.blockId);
    if(card)this.rail.scrollTo({left:card.offsetLeft-this.rail.offsetLeft,behavior:'instant'});
   },opts);
   this.update();
  }
  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.querySelectorAll('dialog[open]').forEach(d=>d.close());}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reference-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reference-footer')) {
    customElements.define(
      'reference-footer',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.controller = new AbortController();

          const options = {
            signal: this.controller.signal
          };

          this.addEventListener(
            'change',
            (event) => {
              if (
                event.target instanceof HTMLSelectElement &&
                event.target.matches('.rf-footer__localization select')
              ) {
                event.target.form?.requestSubmit();
              }
            },
            options
          );

          this.querySelector('[data-footer-top]')?.addEventListener(
            'click',
            () => {
              const behavior = window.matchMedia(
                '(prefers-reduced-motion: reduce)'
              ).matches
                ? 'auto'
                : 'smooth';

              for (
                let node = this.parentElement;
                node;
                node = node.parentElement
              ) {
                if (node.scrollTop > 0) {
                  node.scrollTo({ top: 0, behavior });
                }
              }

              window.scrollTo({ top: 0, behavior });
            },
            options
          );
        }

        disconnectedCallback() {
          this.controller?.abort();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reference-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('reference-card-rail')) {
 customElements.define('reference-card-rail', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.abort = new AbortController();
   const opts = {signal:this.abort.signal};
   this.rail=this.querySelector('[data-rail]');
   if (!this.rail) return;
   this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
   this.addEventListener('click', e=>{
    const move=e.target.closest('[data-move]');
    if(move){
     const card=this.rail.firstElementChild;
     if(card){const gap=parseFloat(getComputedStyle(this.rail).columnGap)||0;this.rail.scrollBy({left:Number(move.dataset.move)*(card.getBoundingClientRect().width+gap),behavior:this.reduced.matches?'instant':'smooth'});}
    }
    const opener=e.target.closest('[data-quick-view]');
    if(opener){const dialog=document.getElementById(opener.dataset.quickView);if(dialog?.showModal){this.lastOpener=opener;dialog.showModal();}}
    if(e.target.closest('[data-close]')) e.target.closest('dialog')?.close();
    if(e.target.tagName==='DIALOG'){
     const r=e.target.getBoundingClientRect();
     if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)e.target.close();
    }
   },opts);
   this.querySelectorAll('dialog').forEach(d=>d.addEventListener('close',()=>this.lastOpener?.focus(),opts));
   this.update=()=>{
    const max=this.rail.scrollWidth-this.rail.clientWidth;
    const prev=this.querySelector('[data-move="-1"]'),next=this.querySelector('[data-move="1"]');
    if(prev){prev.hidden=max<2;prev.disabled=this.rail.scrollLeft<=1;}
    if(next){next.hidden=max<2;next.disabled=this.rail.scrollLeft>=max-1;}
   };
   this.rail.addEventListener('scroll',this.update,{...opts,passive:true});
   this.resize=new ResizeObserver(this.update);this.resize.observe(this.rail);
   this.addEventListener('shopify:block:select',e=>{
    const card=[...this.rail.children].find(c=>c.dataset.blockId===e.detail?.blockId);
    if(card)this.rail.scrollTo({left:card.offsetLeft-this.rail.offsetLeft,behavior:'instant'});
   },opts);
   this.update();
  }
  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.querySelectorAll('dialog[open]').forEach(d=>d.close());}
 });
}

if (!customElements.get('reference-ticker')) {
 customElements.define('reference-ticker', class extends HTMLElement {
  connectedCallback(){
   this.controller?.abort();this.controller=new AbortController();
   const button=this.querySelector('.rf-ticker__pause');
   button?.addEventListener('click',()=>{
    const paused=this.toggleAttribute('data-paused');
    button.setAttribute('aria-pressed',String(paused));
    button.setAttribute('aria-label',paused?'Resume scrolling text':'Pause scrolling text');
    button.firstElementChild.textContent=paused?'▶':'Ⅱ';
   },{signal:this.controller.signal});
  }
  disconnectedCallback(){this.controller?.abort();}
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-goal-links"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('reference-link-card-rail')) {
 customElements.define('reference-link-card-rail', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.abort = new AbortController();
   const opts = {signal:this.abort.signal};
   this.rail=this.querySelector('[data-rail]');
   if (!this.rail) return;
   this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
   this.addEventListener('click', e=>{
    const move=e.target.closest('[data-move]');
    if(move){
     const card=this.rail.firstElementChild;
     if(card){const gap=parseFloat(getComputedStyle(this.rail).columnGap)||0;this.rail.scrollBy({left:Number(move.dataset.move)*(card.getBoundingClientRect().width+gap),behavior:this.reduced.matches?'instant':'smooth'});}
    }
    const opener=e.target.closest('[data-quick-view]');
    if(opener){const dialog=document.getElementById(opener.dataset.quickView);if(dialog?.showModal){this.lastOpener=opener;dialog.showModal();}}
    if(e.target.closest('[data-close]')) e.target.closest('dialog')?.close();
    if(e.target.tagName==='DIALOG'){
     const r=e.target.getBoundingClientRect();
     if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)e.target.close();
    }
   },opts);
   this.querySelectorAll('dialog').forEach(d=>d.addEventListener('close',()=>this.lastOpener?.focus(),opts));
   this.update=()=>{
    const max=this.rail.scrollWidth-this.rail.clientWidth;
    const prev=this.querySelector('[data-move="-1"]'),next=this.querySelector('[data-move="1"]');
    if(prev){prev.hidden=max<2;prev.disabled=this.rail.scrollLeft<=1;}
    if(next){next.hidden=max<2;next.disabled=this.rail.scrollLeft>=max-1;}
   };
   this.rail.addEventListener('scroll',this.update,{...opts,passive:true});
   this.resize=new ResizeObserver(this.update);this.resize.observe(this.rail);
   this.addEventListener('shopify:block:select',e=>{
    const card=[...this.rail.children].find(c=>c.dataset.blockId===e.detail?.blockId);
    if(card)this.rail.scrollTo({left:card.offsetLeft-this.rail.offsetLeft,behavior:'instant'});
   },opts);
   this.update();
  }
  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.querySelectorAll('dialog[open]').forEach(d=>d.close());}
 });
}

  } catch(e) { console.error(e); }
})();
})();
